import React from 'react';
import { isEqual } from 'lodash';
import GeoJSON from 'ol/format/GeoJSON';

import {
  FilterButtonsWrapper,
  FilterButtons,
  FilterWrapper,
  FilterTitle,
  FilterHeader,
  FilterCloseButton,
  FilterValueInput,
  FilterAfegirButton,
  FilterConditionWrapper,
  FilterSubConditionWrapper,
  FilterSubConditionFilters,
  FilterOperatorTextWrapper,
  FilterDeleteButton,
  FilterCercarButton,
  FilterOptObl,
  FilterAddButtonsWrapper,
  FilterNetejarButton,
  FilterSVG,
  FilterAndOrButton,
  FilterDeleteOperatorWrapper,
  FilterCatImg,
  FilterDataList,
  FilterDataListOption,
  FilterAfegirButtonSub,
  FilterSelector,
  FilterSelectedTitle,
  FilterOptionsContainer,
  FilterOptionWrapper,
  FilterOptionTitle
} from './TaulaFilterElement';
import WKT from 'ol/format/WKT.js';

import { transformExtent, toLonLat, fromLonLat } from 'ol/proj';
import Draw, { createBox } from 'ol/interaction/Draw.js';
import { getFeatureTitles, CQLStringMaker, getAutocomplete, getFieldsType } from './TaulaUtils';
import { circular } from 'ol/geom/Polygon';
import CatON from '../../../../../../images/icon-catalunya-ON.png';
import CatOFF from '../../../../../../images/icon-catalunya-OFF.png';
import Polygon from 'ol/geom/Polygon.js';
import { getTranslatedKey } from '../../../../../Utils/TranslateUtils';
import { styleFunction } from './../../../../../VectorTilesTools/VectorTilesUtils';
import { config } from '../../../../../../config/Config';
import { createLayer } from '../../../../../Utils/MapUtils';
import { getParentURL } from '../../../../../Utils/APIUtils';

const format = new WKT();

//Operadores para los filtros, luego se sustituye "value" por el valor del campo. ILIKE en vez de LIKE para que no tenga en cuanta mayus/minus

// comença per
const operators = [
  { [getTranslatedKey('operatorIgual')]: '= value' },
  { [getTranslatedKey('operatorNoIgual')]: ' <> value' },
  { [getTranslatedKey('operatorBigger')]: '> value' },
  { [getTranslatedKey('operatorSmaller')]: '< value' },
  { [getTranslatedKey('operatorBiggerEqual')]: '>= value' },
  { [getTranslatedKey('operatorSmallerEqual')]: '<= value' },
  { [getTranslatedKey('operatorNull')]: 'IS NULL' },
  { [getTranslatedKey('operatorNotNull')]: 'IS NOT NULL' }
];

// conté
const strOperators = [
  { [getTranslatedKey('operatorIgual')]: "ILIKE 'value'" },
  { [getTranslatedKey('operatorNoIgual')]: ' <> value' },
  { [getTranslatedKey('operatorStarts')]: "ILIKE 'value%25'" },
  { [getTranslatedKey('operatorEnds')]: "ILIKE '%25value'" },
  { [getTranslatedKey('operatorHas')]: "ILIKE '%25value%25'" },
  { [getTranslatedKey('operatorNotHas')]: "NOT ILIKE '%25value%25'" },
  { [getTranslatedKey('operatorNull')]: 'IS NULL' },
  { [getTranslatedKey('operatorNotNull')]: 'IS NOT NULL' }
];

let draw;

let closeSvg = (
  <svg viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" width="22" height="22" class="sc-ayeQl">
    <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
  </svg>
);

export class TaulaFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      titles: [getTranslatedKey('filterLoading')],
      placeholders: null,
      conditions: [{ field: '', operator: '', value: '' }],
      operator: 'AND',
      bbox: undefined,
      filterSelected: 'CAT',
      autocomplete: [],
      showList: false,
      fieldTypes: null,
      selectorOptions: [undefined, undefined, undefined]
    };
    this.layerGeom = this.props.layer.getExtension().Geometry;
  }

  /**
   *
   * @desc Función que se llama cuando el componente aparece. Hace una llamada para definir los campos de la capa en los que se puede filtrar
   */
  componentDidMount = async () => {
    this.props.scrollToFiltre(this.props.layer);
    if (this.props.taulaSpacialFilter[this.props.layer.getTitle()] === undefined) {
      this.props.setTaulaSpacialFilter(this.props.layer, 'CAT');
    }
    let titles = [];

    if (this.props.taulaResp[this.props.layer.getTitle()] !== undefined) {
      for (const key in this.props.taulaResp[this.props.layer.getTitle()].features[0].properties) {
        let properties = this.props.layer.getProperties();
        let title = properties.find((title) => title.name === key);
        if (title && title !== this.props.layer.getExtension().Id) {
          titles.push(title.alias);
        }
      }
    }

    this.setState(
      {
        conditions:
          this.props.taulaConditions[this.props.layer.getTitle()] !== undefined
            ? this.props.taulaConditions[this.props.layer.getTitle()]
            : [{ field: '', operator: '', value: '' }],
        placeholders:
          this.props.taulaResp[this.props.layer.getTitle()] !== undefined ? this.props.taulaResp[this.props.layer.getTitle()].features[0] : null,
        titles: this.props.taulaResp[this.props.layer.getTitle()] !== undefined ? titles : ['Carregant...'],
        bbox:
          this.props.taulaSpacialBbox[this.props.layer.getTitle()] !== undefined
            ? this.props.taulaSpacialBbox[this.props.layer.getTitle()]
            : undefined,
        fieldTypes: await getFieldsType(this.props.layer, this.props.user)
      },

      async () => {
        let resp = await getFeatureTitles(this.props.layer, this.props.user);
        this.props.setTaulaResp(this.props.layer, resp);
        let properties = this.props.layer.getProperties();
        let propTitles = [];
        for (const key in resp.features[0]?.properties) {
          let property = properties.find((propertyObj) => propertyObj.name === key);
          if (property && property !== this.props.layer.getExtension().Id) {
            propTitles.push(property.alias);
          }
        }
        this.setState({
          titles: propTitles,
          placeholders: resp.features[0].properties
        });
      }
    );
  };

  componentDidUpdate = (prevProps, prevState) => {
    const title = this.props.layer.getTitle();
    if (
      this.props.taulaApiConditions[title] !== undefined &&
      !isEqual(this.props.taulaApiConditions[title], prevProps.taulaApiConditions[title]) &&
      !isEqual(this.props.taulaApiConditions[title], this.state.conditions)
    ) {
      this.setState({ conditions: this.props.taulaApiConditions[title] });
    }
    if (!isEqual(this.state.conditions, this.props.taulaConditions[title])) {
      this.props.setTaulaConditions(this.props.layer, this.state.conditions);
    }
  };

  /**
   *
   * @desc funcion que se llama al cerrar el filtro. Reincia todo lo que tiene que ver con el filtraje
   */
  onCloseButton = () => {
    this.props.setTaulaSpacialFilter(this.props.layer, 'CAT');
    this.setState({ bbox: undefined }, () => {
      this.props.setTaulaSpacialBbox(this.props.layer, undefined);
    });
    this.props.filterVector.getSource().clear();
    this.props.map.removeInteraction(draw);
    // this.props.resetSelected(this.props.layer);
    this.props.openTableFilters();
    this.forceUpdate();
  };

  /**
   *
   * @desc funcion que se llama al entrar al modo seleccionar
   */
  handleSelect = () => {
    this.props.resetSelected(); // resetamos los array de features seleccionadas
    this.props.toggleSelecting(true, this.props.layer); //Entramos en modo seleccionar y pasamos la capa
  };

  /**
   *
   * @param {*} type
   * @desc función que define que tipo de filtro espacial vamos a usar
   */
  onFilterClick = (type) => {
    if (type === this.props.taulaSpacialFilter[this.props.layer.getTitle()]) {
      if (type === 'CAT') {
        return;
      }
    }
    if (type === 'SELECT') {
      this.props.filterVector.getSource().clear();
      this.props.map.removeInteraction(draw);
      this.props.setTaulaSpacialFilter(this.props.layer, 'SELECT');
      if (window.innerWidth < 768) {
        this.props.changeLlegendaOpen(false);
      }

      this.setState({ bbox: undefined }, async () => {
        this.handleSelect();
      });
    }

    if (type === 'BBOX') {
      this.props.resetSelected();
      this.props.setTaulaSpacialFilter(this.props.layer, type);
      this.props.filterVector.getSource().clear();
      this.props.map.removeInteraction(draw);
    } else if (type === 'CAT') {
      this.props.resetSelected();
      this.props.filterVector.getSource().clear();
      this.props.map.removeInteraction(draw);
      this.props.setTaulaSpacialFilter(this.props.layer, 'CAT');

      this.setState({ bbox: undefined }, () => {
        this.props.setTaulaSpacialBbox(this.props.layer, undefined);
      });
    } else if (type !== 'SELECT') {
      this.props.resetSelected();
      this.props.filterVector.getSource().clear();
      this.props.map.removeInteraction(draw);
      this.addInteraction(type);
      this.props.setTaulaSpacialFilter(this.props.layer, type);
    }
  };

  filterReset = () => {
    if (this.state.bbox) {
      this.setState({ bbox: undefined }, () => {
        this.props.setTaulaSpacialBbox(this.props.layer, undefined);
      });
    }
    this.props.setTaulaSpacialFilter(this.props.layer, null);
    this.props.resetSelected();
    this.props.filterVector.getSource().clear();
  };

  /**
   *
   * @param {*} type
   * @desc Función encargada de gestionar la información de la figura que elegimos pintar
   */
  addInteraction = (type) => {
    let self = this;
    let isSquare = false;
    if (window.innerWidth < 768) {
      this.props.changeLlegendaOpen(false);
    }
    if (type !== 'None') {
      let geometryFunction;
      if (type === 'Square') {
        isSquare = true;
        type = 'Circle';
        geometryFunction = createBox();
      }
      draw = new Draw({
        source: this.props.filterSource,
        type: type, //tipo de la figura
        freehand: type !== 'Polygon' ? true : false, //Si no es polígono, empiezas a pintar nada más hacer click en el mapa
        style: (feature) => {
          return styleFunction(feature, false, false, undefined, true);
        },
        geometryFunction: geometryFunction
      });
      draw.set('name', 'filter');

      //Para eliminar la interacción Draw de las herramientas de medida
      let vector = this.props.map
        .getInteractions()
        .getArray()
        .find(function (interaction) {
          return interaction.get('name') === 'vector';
        });
      if (vector) {
        this.props.map.removeInteraction(vector);
      }

      draw.on('drawstart', () => {
        this.props.filterVector.getSource().clear(); //Limpiamos figuras anteriores
        this.props.toggleDrawing(true); // Activamos el modo dibujo para evitar que salgan chinchetas al hacer click
      });
      draw.on('drawend', (evt) => {
        if (window.innerWidth < 768) {
          this.props.changeLlegendaOpen(true);
        }
        if (type === 'Polygon') {
          //Si es un polígono, mandaremos la figura en formato WKT
          let pol = evt.feature.getGeometry();
          this.props.setTaulaGeom(this.props.layer, pol.getCoordinates());
          pol = pol.transform(config.EPSG_mapa, config.EPSG);
          let wkt = format.writeGeometry(pol);
          let geo = this.props.taulaResp[this.props.layer.getTitle()]?.features[0]?.geometry_name || undefined;
          wkt = geo ? `INTERSECTS(${geo}, ${wkt})` : `INTERSECTS(${this.layerGeom}, ${wkt})`;
          self.setState({ bbox: wkt }, () => {
            self.props.map.removeInteraction(draw);
            self.props.toggleDrawing(false);
            this.props.setTaulaSpacialBbox(this.props.layer, wkt);
          });
          pol = pol.transform(config.EPSG, config.EPSG_mapa);
        } else if (type === 'Circle' && isSquare === false) {
          //Si es circulo hay que aproximarlo a polígono y mandarlo en WKT
          //Obtenemos centro y radio
          let center = evt.feature.getGeometry().getCenter();
          let radius = evt.feature.getGeometry().getRadius();
          radius = radius * 0.74;

          //Pasamos el centro a Long Lat porque así lo pide la función circular
          center = toLonLat(center, config.EPSG_mapa);
          //función que aproxima el círculo a un polígono de 32 vértices
          let circlePol = circular(center, radius);

          //Obtenemos las coordenadas del polígono y las transformamos a la proyección que usamos
          let circlePolConverted = circlePol.getCoordinates()[0].map((coord) => {
            return fromLonLat(coord, config.EPSG);
          });
          const pol = new Polygon([circlePolConverted]);
          this.props.setTaulaGeom(this.props.layer, pol.getCoordinates());

          //Generamos un nuevo polígono con el array de coordenadas que hemos conseguido antes y lo formateamos a WKT
          let wkt = format.writeGeometry(pol);
          let geo = this.props.taulaResp[this.props.layer.getTitle()]?.features[0]?.geometry_name || undefined;
          wkt = geo ? `INTERSECTS(${geo}, ${wkt})` : `INTERSECTS(${this.layerGeom}, ${wkt})`;
          self.setState({ bbox: wkt }, () => {
            this.props.setTaulaSpacialBbox(this.props.layer, wkt);
            self.props.map.removeInteraction(draw);
            self.props.toggleDrawing(false);
          });
        } else {
          let bbox = evt.feature.getGeometry().getExtent();
          this.props.setTaulaGeom(this.props.layer, bbox);

          bbox = transformExtent(bbox, config.EPSG_mapa, config.EPSG);
          let geo = this.props.taulaResp[this.props.layer.getTitle()]?.features[0]?.geometry_name || undefined;
          bbox = geo ? `BBOX(${geo}, ${bbox})` : `BBOX(${this.layerGeom}, ${bbox})`;
          self.setState({ bbox: bbox }, () => {
            this.props.setTaulaSpacialBbox(this.props.layer, bbox);
            self.props.map.removeInteraction(draw);
            self.props.toggleDrawing(false);
          });
        }
        return;
      });
    }
    this.props.map.addInteraction(draw);
  };

  /**
   *
   * @desc Función que resetea el filtro al estado inicial
   */
  handleFilterCancel = () => {
    this.setState({ conditions: [{ field: '', operator: '', value: '' }], bbox: undefined }, async () => {
      this.props.filterVector.getSource().clear();
      await this.props.resetSelected(this.props.layer, true);
      if (this.props.taulaArray[this.props.layer.getTitle()] !== undefined) {
        this.handleClickCerca(true);
      } else {
        this.props.deleteTaula(this.props.layer);
        this.updateLayer();
      }
    });
    this.props.setTaulaSpacialFilter(this.props.layer, 'CAT');
    this.props.setTaulaGeom(this.props.layer, undefined);
  };

  //Funciones para los filtros

  /**
   *
   * @param {*} operator AND/OR
   * @desc Función que setea el operador global a AND u OR
   */
  operatorChange = (operator) => {
    this.setState({ operator: operator });
  };

  /**
   *
   * @param {*} operator Operador al que queremos cambiar
   * @param {*} index Índice de la subcláusula en el array conditions
   * @desc Función que cambia el operador para la subcláusula seleccionada
   */
  subGroupOperatorChange = (operator, index) => {
    this.setState((prevState) => {
      const newConditions = [...prevState.conditions];
      newConditions[index].groupOperator = operator;
      return { conditions: newConditions };
    });
  };

  /**
   *
   * @desc Función para añadir una condición global a la lista de condiciones
   */
  handleAddCondition = () => {
    this.setState((prevState) => ({
      conditions: [...prevState.conditions, { field: '', operator: '', value: '' }]
    }));
  };

  /**
   *
   * @param {*} index Índice de la subcláusula en el array conditions
   * @desc Función para añadir una condición a la subcláusula seleccionada
   */
  handleAddSubCondition = (index) => {
    this.setState((prevState) => {
      const newConditions = [...prevState.conditions];
      newConditions[index].filters.push({ field: '', operator: '', value: '' });
      return { conditions: newConditions };
    });
  };

  /**
   *
   * @desc Función para añadir una subcláusula
   */
  handleAddSubClause = () => {
    this.setState((prevState) => ({
      conditions: [
        ...prevState.conditions,
        {
          type: 'group',
          groupOperator: 'AND',
          filters: [
            { field: '', operator: '', value: '' },
            { field: '', operator: '', value: '' }
          ]
        }
      ]
    }));
  };

  /**
   *
   * @param {*} index Índice de la condición en el array conditions
   * @desc Función para borrar una condición global
   */
  handleDeleteCondition = (index) => {
    this.setState((prevState) => {
      if (prevState.conditions.length > 1) {
        const newConditions = [...prevState.conditions];
        newConditions.splice(index, 1);
        return { conditions: newConditions };
      } else {
        this.setState({ conditions: [{ field: '', operator: '', value: '' }] });
      }
      return null;
    });
  };

  /**
   *
   * @param {*} index Índice de la subcláusula en el array conditions
   * @param {*} subIndex Índice de la condición en el array de filtros de la subcláusula
   * @desc Función para borrar una condición en una subcláusula
   */
  handleDeleteSubCondition = (index, subIndex) => {
    this.setState((prevState) => {
      const newConditions = [...prevState.conditions];
      if (prevState.conditions[index].filters.length > 1) {
        newConditions[index].filters.splice(subIndex, 1);
        return { conditions: newConditions };
      } else {
        newConditions.splice(index, 1);
        return { conditions: newConditions };
      }
    });
  };

  /**
   *
   * @param {*} index Índice de la condición en el array conditions
   * @param {*} type Tipo del campo que queramos cambiar (field, operator o value)
   * @param {*} value Valor nuevo del campo que queramos cambiar
   * @param {*} subIndex En caso de que sea subcláusula, índice de la condición en el array de filtros de la subcláusula. Si no, debe quedar vacío.
   * @desc Función para editar una condición
   */
  handleChange = async (index, type, value, subIndex) => {
    this.setState({ autocomplete: [], selectorOptions: [undefined, undefined, undefined] });
    let phValue;
    if (type === 'field') {
      let properties = this.props.layer.getProperties();
      phValue = properties.find((prop) => prop.alias === value)?.name || value;
    } else {
      let properties = this.props.layer.getProperties();

      const val = subIndex !== undefined ? this.state.conditions[index].filters[subIndex].field : this.state.conditions[index].field;
      phValue = properties.find((prop) => prop.alias === val)?.name || val;
    }
    if (subIndex !== undefined) {
      this.setState((prevState) => {
        const newConditions = [...prevState.conditions];
        // Elegir operador por defecto según el tipo de data del campo en la base de datos
        if (type === 'field' && newConditions[index].filters[subIndex][type] === '') {
          if (this.state.fieldTypes?.[phValue] === 'number' || this.state.fieldTypes?.[phValue] === 'date') {
            newConditions[index].filters[subIndex].operator = '= value';
          } else {
            newConditions[index].filters[subIndex].operator = "ILIKE '%25value%25'";
          }
        } else if (type === 'field' && newConditions[index].filters[subIndex][type] !== '') {
          if (
            (this.state.fieldTypes?.[phValue] === 'number' || this.state.fieldTypes?.[phValue] === 'date') &&
            !operators.hasOwnProperty(newConditions[index].filters[subIndex].operator)
          ) {
            newConditions[index].filters[subIndex].operator = '= value';
          } else if (this.state.fieldTypes?.[phValue] !== 'number' && !strOperators.hasOwnProperty(newConditions[index].filters[subIndex].operator)) {
            newConditions[index].filters[subIndex].operator = "ILIKE '%25value%25'";
          }
        }
        if (type === 'operator') {
          let valor;
          if (this.state.fieldTypes?.[phValue] === 'number' || this.state.fieldTypes?.[phValue] === 'date') {
            valor = operators.find((op) => op.hasOwnProperty(value));
            if (valor) {
              valor = Object.values(valor)[0];
            }
          } else {
            valor = strOperators.find((op) => op.hasOwnProperty(value));
            if (valor) {
              valor = Object.values(valor)[0];
            }
          }
          newConditions[index].filters[subIndex][type] = valor;
          return { conditions: newConditions };
        }
        newConditions[index].filters[subIndex][type] = value;
        return { conditions: newConditions };
      });

      let endsWith = this.state.conditions[index].filters[subIndex].operator === "ILIKE '%25value'" ? true : undefined;

      if (value.length > 2 && this.state.conditions[index].filters[subIndex].field !== '') {
        let results = await getAutocomplete(
          this.props.layer,
          this.state.conditions[index].filters[subIndex].field,
          this.state.fieldTypes?.[phValue],
          value,
          endsWith,
          this.props.user
        );
        this.setState({ autocomplete: results });
      }
    } else {
      this.setState((prevState) => {
        const newConditions = [...prevState.conditions];
        // Elegir operador por defecto según el tipo de data del campo en la base de datos
        if (type === 'field' && newConditions[index][type] === '') {
          if (this.state.fieldTypes?.[phValue] === 'number' || this.state.fieldTypes?.[phValue] === 'date') {
            newConditions[index].operator = '= value';
          } else {
            newConditions[index].operator = "ILIKE '%25value%25'";
          }
        } else if (type === 'field' && newConditions[index][type] !== '') {
          if (
            (this.state.fieldTypes?.[phValue] === 'number' || this.state.fieldTypes?.[phValue] === 'date') &&
            !operators.hasOwnProperty(newConditions[index].operator)
          ) {
            newConditions[index].operator = '= value';
          } else if (this.state.fieldTypes?.[phValue] !== 'number' && !strOperators.hasOwnProperty(newConditions[index].operator)) {
            newConditions[index].operator = "ILIKE '%25value%25'";
          }
        }
        if (type === 'operator') {
          let valor;
          if (this.state.fieldTypes?.[phValue] === 'number' || this.state.fieldTypes?.[phValue] === 'date') {
            valor = operators.find((op) => op.hasOwnProperty(value));
            if (valor) {
              valor = Object.values(valor)[0];
            }
          } else {
            valor = strOperators.find((op) => op.hasOwnProperty(value));
            if (valor) {
              valor = Object.values(valor)[0];
            }
          }
          newConditions[index][type] = valor;
          return { conditions: newConditions };
        }
        newConditions[index][type] = value;
        return { conditions: newConditions };
      });
      let endsWith = this.state.conditions[index].operator === "ILIKE '%25value'" ? true : undefined;

      if (value.length > 2 && this.state.conditions[index].field !== '') {
        let results = await getAutocomplete(
          this.props.layer,
          this.state.conditions[index].field,
          this.state.fieldTypes?.[phValue],
          value,
          endsWith,
          this.props.user
        );
        this.setState({ autocomplete: results });
      }
    }
  };
  onClickSelector = (index, subIndex, part) => {
    let options = this.state.selectorOptions;
    if (options[0] === index && options[1] === subIndex) {
      this.setState({ selectorOptions: [undefined, undefined, undefined] });
    } else if (subIndex !== undefined) {
      this.setState({ selectorOptions: [index, subIndex, part] });
    } else {
      this.setState({ selectorOptions: [index, undefined, part] });
    }
  };
  /**
   *
   * @param {*} index Índice de la condición en el array conditions
   * @param {*} subIndex En caso de que sea subcláusula, índice de la condición en el array de filtros de la subcláusula. Sirve para pasarlo como argumento a la función handleChange
   * @desc Función para renderizar los campos de la capa por la cual se puede filtrar
   */
  renderTitles = (index, subIndex) => {
    let value;
    let options = this.state.selectorOptions;
    let render = options[2] === 'field' && index === options[0] && subIndex === options[1];

    if (subIndex !== undefined) {
      value = this.state.conditions[index].filters[subIndex].field;
    } else {
      value = this.state.conditions[index].field;
    }
    return (
      <>
        <FilterSelector onClick={() => this.onClickSelector(index, subIndex, 'field')}>
          <FilterSelectedTitle fontSizeEnabled={this.props.fontSizeEnabled}>
            {value === '' ? getTranslatedKey('filterSelectField') : value}
          </FilterSelectedTitle>
          <svg focusable="false" aria-hidden="true" width="20" fill="white" viewBox="0 0 24 24" data-testid="ExpandMoreIcon">
            <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
          </svg>
        </FilterSelector>
        {render &&
          (this.state.titles.length === 0 ? (
            getTranslatedKey('filterLoading')
          ) : (
            <FilterOptionsContainer>
              {this.state.titles?.map((key, i) => {
                return (
                  <FilterOptionWrapper
                    group={subIndex !== undefined}
                    onClick={() => this.handleChange(index, 'field', key, subIndex)}
                    onMouseEnter={() => this.setState({ optionHover: i })}
                    onMouseLeave={() => this.setState({ optionHover: i })}
                    isHover={window.innerWidth > 768 && this.state.optionHover === i}>
                    <FilterOptionTitle fontSizeEnabled={this.props.fontSizeEnabled}>{key}</FilterOptionTitle>
                  </FilterOptionWrapper>
                );
              })}
            </FilterOptionsContainer>
          ))}
      </>
    );
  };

  /**
   *
   * @param {*} index Índice de la condición en el array conditions
   * @param {*} subIndex En caso de que sea subcláusula, índice de la condición en el array de filtros de la subcláusula. Sirve para mandarla a la función handleChange
   * @desc Función para renderizar los operadores para el filtro
   */
  renderOperators = (index, subIndex) => {
    let value;
    let options = this.state.selectorOptions;
    let render = options[2] === 'operator' && index === options[0] && subIndex === options[1];
    if (subIndex !== undefined) {
      value = this.state.conditions[index].filters[subIndex].operator;
    } else {
      value = this.state.conditions[index].operator;
    }
    //Condiciones para definir que tipo de operador debe usarse
    const properties = this.props.layer.getProperties();

    let list = operators;
    if (subIndex !== undefined) {
      let cond = this.state.conditions[index].filters[subIndex].field;
      let field = properties.find((prop) => prop.alias === cond)?.name || cond;

      if (field !== '' && field !== getTranslatedKey('filterLoading')) {
        if (this.state.fieldTypes?.[field] === 'number' || this.state.fieldTypes?.[field] === 'date') {
          list = operators;
        } else {
          list = strOperators;
        }
      }
    } else {
      let cond = this.state.conditions[index].field;
      let field = properties.find((prop) => prop.alias === cond)?.name || cond;

      if (field !== '' && field !== getTranslatedKey('filterLoading')) {
        if (this.state.fieldTypes?.[field] === 'number' || this.state.fieldTypes?.[field] === 'date') {
          list = operators;
        } else {
          list = strOperators;
        }
      }
    }
    let key = list.find((op) => Object.entries(op).find(([key, val]) => val === value));

    if (key) {
      key = Object.keys(key)[0];
    }
    return (
      <>
        <FilterSelector onClick={() => this.onClickSelector(index, subIndex, 'operator')}>
          <FilterSelectedTitle fontSizeEnabled={this.props.fontSizeEnabled}>
            {value === '' ? getTranslatedKey('filterSelectoperator') : key}
          </FilterSelectedTitle>
          <svg focusable="false" aria-hidden="true" width="20" fill="white" viewBox="0 0 24 24" data-testid="ExpandMoreIcon">
            <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
          </svg>
        </FilterSelector>
        {render &&
          (list.length === 0 ? (
            getTranslatedKey('filterLoading')
          ) : (
            <FilterOptionsContainer operator>
              {list?.map((object, i) =>
                Object.keys(object).map((op) => {
                  return (
                    <FilterOptionWrapper
                      group={subIndex}
                      onClick={() => this.handleChange(index, 'operator', op, subIndex)}
                      onMouseEnter={() => this.setState({ optionHover: i })}
                      onMouseLeave={() => this.setState({ optionHover: i })}
                      isHover={window.innerWidth > 768 && this.state.optionHover === i}>
                      <FilterOptionTitle fontSizeEnabled={this.props.fontSizeEnabled}>{op}</FilterOptionTitle>
                    </FilterOptionWrapper>
                  );
                })
              )}
            </FilterOptionsContainer>
          ))}
      </>
    );
  };

  /**
   *
   * @desc Función que decide si una condición debe poderse borrar (solo dará false en el caso de que solo haya una condición global activa)
   */
  canDelete = () => {
    let count = 0;
    this.state.conditions.forEach((cond) => {
      if (cond.type !== 'group') {
        count = count + 1;
      }
    });
    if (count > 1) {
      return true;
    } else {
      if (
        this.state.conditions.length === 1 &&
        (this.state.conditions[0].value !== '' || this.state.conditions[0].operator !== '' || this.state.conditions[0].field !== '')
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  /**
   *
   * @desc Función que muestra las condiciones en la leyenda
   */
  renderConditions = () => {
    let conditions = this.state.conditions;

    return conditions.map((condition, index) => {
      // Si es una subcláusiula
      if (condition.type === 'group') {
        return (
          <>
            <FilterSubConditionWrapper key={index}>
              {condition.filters.map((filter, subIndex) => {
                const properties = this.props.layer.getProperties();
                const PHValue = properties.find((prop) => prop.alias === filter.field)?.name;
                return (
                  // para cada subcondición, renderizamos los 3 inputs, el botón de eliminar y los operadores
                  <>
                    <FilterSubConditionFilters key={subIndex}>
                      {this.renderTitles(index, subIndex)}
                      {this.renderOperators(index, subIndex)}
                      {filter.operator !== 'IS NULL' && filter.operator !== 'IS NOT NULL' && (
                        <FilterValueInput
                          group
                          onBlur={() =>
                            setTimeout(() => {
                              this.setState({ showList: false });
                            }, 200)
                          }
                          onInput={() => this.inputRecs(index, subIndex)}
                          list={filter.value}
                          placeholder={
                            filter.field !== '' &&
                            filter.field !== getTranslatedKey('filterLoading') &&
                            this.state.placeholders &&
                            this.state.placeholders[PHValue] !== undefined &&
                            this.state.placeholders[PHValue] !== null
                              ? getTranslatedKey('filterExemple') + this.state.placeholders[PHValue]?.toString()
                              : getTranslatedKey('filterIntroduce')
                          }
                          value={filter.value}
                          onChange={(event) => this.handleChange(index, 'value', event.target.value, subIndex)}
                        />
                      )}
                      <FilterDataList
                        group
                        show={
                          this.state.showList &&
                          this.state.autocomplete?.length > 0 &&
                          this.state.listIndex[0] === index &&
                          this.state.listIndex[1] === subIndex
                        }
                        id={filter.value}>
                        {this.renderAutocomplete(index, subIndex)}
                      </FilterDataList>
                      <FilterDeleteOperatorWrapper>
                        <FilterDeleteButton group onClick={() => this.handleDeleteSubCondition(index, subIndex)}>
                          {closeSvg}
                        </FilterDeleteButton>
                        {subIndex === conditions[index].filters.length - 1 ? null : (
                          <FilterOperatorTextWrapper fontSizeEnabled={this.props.fontSizeEnabled}>
                            <FilterAndOrButton
                              fontSizeEnabled={this.props.fontSizeEnabled}
                              group
                              selected={conditions[index].groupOperator === 'AND'}
                              onClick={() => this.subGroupOperatorChange('AND', index)}>
                              AND
                            </FilterAndOrButton>
                            <FilterAndOrButton
                              fontSizeEnabled={this.props.fontSizeEnabled}
                              group
                              selected={conditions[index].groupOperator === 'OR'}
                              onClick={() => this.subGroupOperatorChange('OR', index)}>
                              OR
                            </FilterAndOrButton>
                          </FilterOperatorTextWrapper>
                        )}
                      </FilterDeleteOperatorWrapper>
                    </FilterSubConditionFilters>
                  </>
                );
              })}
              {/* Botón para añadir una condición a la subcláusula */}
              <FilterAfegirButton fontSizeEnabled={this.props.fontSizeEnabled} group onClick={() => this.handleAddSubCondition(index)}>
                {getTranslatedKey('filterAddCond')}
              </FilterAfegirButton>
            </FilterSubConditionWrapper>
            {conditions.length - 1 > index ? (
              <FilterOperatorTextWrapper fontSizeEnabled={this.props.fontSizeEnabled}>
                {
                  <>
                    <FilterAndOrButton
                      fontSizeEnabled={this.props.fontSizeEnabled}
                      selected={this.state.operator === 'AND'}
                      onClick={() => this.operatorChange('AND')}>
                      AND
                    </FilterAndOrButton>
                    <FilterAndOrButton
                      fontSizeEnabled={this.props.fontSizeEnabled}
                      selected={this.state.operator === 'OR'}
                      onClick={() => this.operatorChange('OR')}>
                      OR
                    </FilterAndOrButton>
                  </>
                }
              </FilterOperatorTextWrapper>
            ) : null}
          </>
        );
        // Si es una condición global
      } else {
        const properties = this.props.layer.getProperties();
        const PHValue = properties.find((prop) => prop.alias === condition.field)?.name;
        return (
          <>
            <FilterConditionWrapper key={index}>
              {this.renderTitles(index)}
              {this.renderOperators(index)}
              {condition.operator !== 'IS NULL' && condition.operator !== 'IS NOT NULL' && (
                <FilterValueInput
                  onBlur={() =>
                    setTimeout(() => {
                      this.setState({ showList: false });
                    }, 200)
                  }
                  onInput={() => this.inputRecs(index)}
                  value={condition.value}
                  list={condition.value}
                  placeholder={
                    condition.field !== '' &&
                    condition.field !== getTranslatedKey('filterLoading') &&
                    this.state.placeholders &&
                    this.state.placeholders[PHValue] !== undefined &&
                    this.state.placeholders[PHValue] !== null
                      ? getTranslatedKey('filterExemple') + this.state.placeholders[PHValue]?.toString()
                      : getTranslatedKey('filterIntroduce')
                  }
                  onChange={(event) => this.handleChange(index, 'value', event.target.value)}
                />
              )}
              <FilterDataList
                show={this.state.showList && this.state.autocomplete?.length > 0 && this.state.listIndex === index}
                id={condition.value}>
                {this.renderAutocomplete(index)}
              </FilterDataList>
              <FilterDeleteOperatorWrapper>
                {this.canDelete() ? <FilterDeleteButton onClick={() => this.handleDeleteCondition(index)}>{closeSvg}</FilterDeleteButton> : null}
                {index !== conditions.length - 1 ? (
                  <FilterOperatorTextWrapper fontSizeEnabled={this.props.fontSizeEnabled}>
                    {
                      <>
                        <FilterAndOrButton
                          fontSizeEnabled={this.props.fontSizeEnabled}
                          selected={this.state.operator === 'AND'}
                          onClick={() => this.operatorChange('AND')}>
                          AND
                        </FilterAndOrButton>
                        <FilterAndOrButton
                          fontSizeEnabled={this.props.fontSizeEnabled}
                          selected={this.state.operator === 'OR'}
                          onClick={() => this.operatorChange('OR')}>
                          OR
                        </FilterAndOrButton>
                      </>
                    }
                  </FilterOperatorTextWrapper>
                ) : null}
              </FilterDeleteOperatorWrapper>
            </FilterConditionWrapper>
          </>
        );
      }
    });
  };

  inputRecs = (idx, grp) => {
    this.setState({}, () => {
      if (grp !== undefined) {
        if (this.state.autocomplete !== undefined && this.state.conditions[idx].filters[grp].value.length > 2) {
          this.setState({ listIndex: [idx, grp], showList: true });
        } else {
          this.setState({ showList: false });
        }
      } else if (this.state.autocomplete !== undefined && this.state.conditions[idx].value.length > 2) {
        this.setState({ listIndex: idx, showList: true });
      } else {
        this.setState({ showList: false });
      }
    });
  };

  optionClick = (option, idx, grp) => {
    if (grp !== undefined) {
      this.handleChange(idx, 'value', option, grp);
    } else {
      this.handleChange(idx, 'value', option);
    }
  };

  renderAutocomplete = (idx, grp) => {
    return this.state.autocomplete?.map((option, i) => (
      <FilterDataListOption
        fontSizeEnabled={this.props.fontSizeEnabled}
        key={i}
        onMouseEnter={() => this.setState({ isOptionHovered: i })}
        onMouseLeave={() => this.setState({ isOptionHovered: false })}
        onClick={() => this.optionClick(option, idx, grp)}
        isHover={this.state.isOptionHovered === i}>
        {option}
      </FilterDataListOption>
    ));
  };

  filtreChecker = () => {
    const layerTitle = this.props.layer.getTitle();
    let count = 0;
    //En caso de que estemos seleccionando
    if (this.props.isSelecting[0]) {
      if (this.props.selectedArray[layerTitle]?.length > 0) {
        return true;
      } else {
        return false;
      }
      //En caso de que queramos buscar solo por BBOX
    } else if (this.state.conditions.length === 1 && (this.state.bbox || this.props.taulaSpacialFilter[layerTitle] === 'BBOX')) {
      let cond = this.state.conditions[0];
      if (cond.field === '' && cond.operator === '' && cond.value === '') {
        return true;
      } else if (cond.field === '' || cond.operator === '' || cond.value === '') {
        return false;
      }
      //Si hay un filtro aplicado dejamos aplicar también solo con el icono de CAT
    } else if (
      this.props.taulaFullFilter[layerTitle] !== undefined &&
      this.props.taulaFullFilter[layerTitle] !== '' &&
      this.state.conditions.length === 1
    ) {
      let cond = this.state.conditions[0];
      if (
        !(cond.field !== '' && (cond.operator === 'IS NULL' || cond.operator === 'IS NOT NULL')) &&
        (cond.field === '' || cond.operator === '' || cond.value === '')
      ) {
        count += 1;
      }
      //Comprobamos las condiciones para decidir si dejamos aplicar o no
    } else {
      this.state.conditions.forEach((cond) => {
        if (cond.type === 'group') {
          cond.filters.forEach((filter) => {
            if (
              !(filter.field !== '' && (filter.operator === 'IS NULL' || filter.operator === 'IS NOT NULL')) &&
              (filter.field === '' || filter.operator === '' || filter.value === '')
            ) {
              count += 1;
            }
          });
        } else {
          if (
            !(cond.field !== '' && (cond.operator === 'IS NULL' || cond.operator === 'IS NOT NULL')) &&
            (cond.field === '' || cond.operator === '' || cond.value === '')
          ) {
            count += 1;
          }
        }
      });
    }
    if (count > 0) {
      return false;
    } else {
      return true;
    }
  };

  updateLayer = async () => {
    let identificador = this.props.layer.getExtension().Id;
    const layerTitle = this.props.layer.getTitle();
    let stringSegment = '';
    let selected = this.props.selectedArray[layerTitle];
    let opacity = this.props.layer.getOLLayer().getOpacity();

    selected?.forEach((ele) => {
      if (stringSegment === '') {
        stringSegment = `${identificador} = ${ele}`;
      } else {
        stringSegment = stringSegment + ` OR ${identificador} = ${ele}`;
      }
    });

    this.props.map.removeLayer(this.props.layer.getOLLayer());
    let filter = '';
    if (this.state.bbox) {
      if (this.props.taulaFilters[layerTitle]) {
        filter = `${this.state.bbox} AND  (${this.props.taulaFilters[layerTitle]})`;
      } else {
        filter = this.state.bbox;
      }
    } else if (selected && selected.length > 0) {
      if (this.props.taulaFilters[layerTitle]) {
        filter = `${stringSegment}`;
      } else {
        filter = stringSegment;
      }
    } else {
      filter = this.props.taulaFilters[layerTitle];
    }

    await createLayer(
      this.props.layer,
      this.props.map,
      this.props.arrayLayers,
      false,
      this.props.layer.getStyle(this.props.layer.getStyleSelected()).getName(),
      filter
    );
    this.props.layer.getOLLayer().setOpacity(opacity);
    this.props.toggleSelecting(false, null);
    this.props.selectVector.getSource().clear(); // esto quita limpia las marcas de las features seleccionadas
    this.props.filterVector.getSource().clear(); // esto quita la figura una vez aplicas el filtro

    // Borramos todas las representaciones de las layers en el mapa.
    this.props.arrayLayers.forEach((capa) => {
      this.props.map.removeLayer(capa.getOLLayer());
    });

    // Pintamos de nuevo todas las layers del array con el nuevo orden revirtiendo el array para que pinte primero las últimas y las siguientes encima.
    this.props.arrayLayers.reverse().forEach((capa) => {
      this.props.map.addLayer(capa.getOLLayer());
    });
    // Revertimos el array de nuevo para recuperar el orden original.
    this.props.arrayLayers.reverse();
  };

  /**
   *
   * @desc Función que se llama cuando hacemos click en buscar
   */
  handleClickCerca = async (deleted) => {
    const title = this.props.layer.getTitle();

    if (this.props.taulaSpacialFilter[title] === 'BBOX') {
      let bbox = this.props.map.getView().calculateExtent(this.props.map.getSize());
      this.props.setTaulaGeom(this.props.layer, bbox);
      bbox = transformExtent(bbox, config.EPSG_mapa, config.EPSG);
      let geo = this.props.taulaResp[title]?.features[0]?.geometry_name || undefined;
      bbox = geo ? `BBOX(${geo}, ${bbox})` : `BBOX(${this.layerGeom}, ${bbox})`;
      this.setState({ bbox: bbox }, () => {
        this.props.setTaulaSpacialBbox(this.props.layer, bbox);
      });
    }
    await this.props.setTaulaFilters(CQLStringMaker(this.state.conditions, this.state.operator, this.props.layer), this.props.layer);
    await this.props.getTaulaArray(this.props.layer, 0, null, this.state.bbox);

    if (deleted) {
      setTimeout(() => {
        const message = {
          infoName: 'tableResult',
          data: {
            layer: this.props.layer.getName(),
            total: this.props.taulaTotal[title],
            page: this.props.taulaPage[title],
            filter: this.props.taulaFilters[title],
            geomFilter: this.props.taulaGeom[title],
            features: new GeoJSON().writeFeatures(this.props.taulaFc[title])
          }
        };
        window.parent.postMessage(message, getParentURL());
      }, 300);
    }
    this.updateLayer();
  };

  render() {
    return (
      <FilterWrapper>
        <FilterHeader>
          <FilterTitle id={`filtre-${this.props.layer.getTitle()}`} fontSizeEnabled={this.props.fontSizeEnabled}>
            {getTranslatedKey('filterTitle')}
          </FilterTitle>
          <FilterCloseButton onClick={() => this.onCloseButton()}>
            <svg
              width="24"
              fill="white"
              transform="rotate(180)"
              focusable="false"
              aria-hidden="true"
              viewBox="0 0 24 24"
              data-testid="ExpandMoreIcon">
              <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
            </svg>
          </FilterCloseButton>
        </FilterHeader>
        <FilterOptObl fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('filterSpacial')}</FilterOptObl>
        <FilterButtonsWrapper>
          <FilterButtons
            title={getTranslatedKey('filterTitleCat')}
            className="filter-catalunya"
            selected={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'CAT'}
            onClick={() => this.onFilterClick('CAT')}>
            <FilterCatImg src={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'CAT' ? CatON : CatOFF} alt="Tota catalunya" />
          </FilterButtons>
          <FilterButtons
            title={getTranslatedKey('filterTitleRound')}
            className="filter-radi"
            onMouseDown={() => this.filterReset()}
            selected={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Circle'}
            onClick={() => this.onFilterClick('Circle')}>
            <FilterSVG selected={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Circle'}>
              <path d="M145,311.8c41.1,41.1,105.2,45.4,151.2,13l70.7,70.7c7.9,7.9,20.7,7.9,28.6,0c7.9-7.9,7.9-20.7,0-28.6l-70.7-70.7  c32.3-46,27.9-110-13.1-151c-46-46-120.7-46-166.7,0C99.1,191,99.1,265.8,145,311.8z M283.1,173.7c30.2,30.2,30.2,79.3,0,109.5  s-79.3,30.2-109.5,0s-30.2-79.3,0-109.5C203.8,143.5,252.9,143.5,283.1,173.7z" />
              <circle
                fill="none"
                stroke={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Circle' ? '#333333' : 'white'}
                strokeWidth="20"
                strokeMiterlimit="10"
                strokeDasharray="50"
                class="st0"
                cx="256.2"
                cy="254.2"
                r="241.7"
              />
            </FilterSVG>
          </FilterButtons>
          <FilterButtons
            title={getTranslatedKey('filterTitleRect')}
            className="filter-rectangle"
            onMouseDown={() => this.filterReset()}
            selected={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Square'}
            onClick={() => this.onFilterClick('Square')}>
            <FilterSVG selected={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Square'}>
              <g>
                <g>
                  <polyline
                    fill="none"
                    stroke={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Square' ? '#333333' : 'white'}
                    strokeWidth="20"
                    strokeMiterlimit="10"
                    points="497.5,474.5 497.5,499.5 472.5,499.5   "
                  />
                  <line
                    fill="none"
                    stroke={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Square' ? '#333333' : 'white'}
                    strokeWidth="20"
                    strokeMiterlimit="10"
                    strokeDasharray="48.1111,48.1111"
                    x1="424.4"
                    y1="499.5"
                    x2="63.6"
                    y2="499.5"
                  />
                  <polyline
                    fill="none"
                    stroke={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Square' ? '#333333' : 'white'}
                    strokeWidth="20"
                    strokeMiterlimit="10"
                    points="39.5,499.5 14.5,499.5 14.5,474.5   "
                  />
                  <line
                    fill="none"
                    stroke={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Square' ? '#333333' : 'white'}
                    strokeWidth="20"
                    strokeMiterlimit="10"
                    strokeDasharray="48.5556,48.5556"
                    x1="14.5"
                    y1="425.9"
                    x2="14.5"
                    y2="61.8"
                  />
                  <polyline
                    fill="none"
                    stroke={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Square' ? '#333333' : 'white'}
                    strokeWidth="20"
                    strokeMiterlimit="10"
                    points="14.5,37.5 14.5,12.5 39.5,12.5   "
                  />
                  <line
                    fill="none"
                    stroke={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Square' ? '#333333' : 'white'}
                    strokeWidth="20"
                    strokeMiterlimit="10"
                    strokeDasharray="48.1111,48.1111"
                    x1="87.6"
                    y1="12.5"
                    x2="448.4"
                    y2="12.5"
                  />
                  <polyline
                    fill="none"
                    stroke={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Square' ? '#333333' : 'white'}
                    strokeWidth="20"
                    strokeMiterlimit="10"
                    points="472.5,12.5 497.5,12.5 497.5,37.5   "
                  />
                  <line
                    fill="none"
                    stroke={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Square' ? '#333333' : 'white'}
                    strokeWidth="20"
                    strokeMiterlimit="10"
                    strokeDasharray="48.5556,48.5556"
                    x1="497.5"
                    y1="86.1"
                    x2="497.5"
                    y2="450.2"
                  />
                </g>
              </g>
              <path d="M145,311.8c41.1,41.1,105.2,45.4,151.2,13l70.7,70.7c7.9,7.9,20.7,7.9,28.6,0c7.9-7.9,7.9-20.7,0-28.6l-70.7-70.7  c32.3-46,27.9-110-13.1-151c-46-46-120.7-46-166.7,0C99.1,191,99.1,265.8,145,311.8z M283.1,173.7c30.2,30.2,30.2,79.3,0,109.5  s-79.3,30.2-109.5,0s-30.2-79.3,0-109.5C203.8,143.5,252.9,143.5,283.1,173.7z" />
            </FilterSVG>
          </FilterButtons>
          <FilterButtons
            title={getTranslatedKey('filterTitleArea')}
            className="filter-area"
            onMouseDown={() => this.filterReset()}
            selected={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Polygon'}
            onClick={() => this.onFilterClick('Polygon')}>
            <FilterSVG selected={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Polygon'}>
              <path d="M145,311.8c41.1,41.1,105.2,45.4,151.2,13l70.7,70.7c7.9,7.9,20.7,7.9,28.6,0c7.9-7.9,7.9-20.7,0-28.6l-70.7-70.7  c32.3-46,27.9-110-13.1-151c-46-46-120.7-46-166.7,0C99.1,191,99.1,265.8,145,311.8z M283.1,173.7c30.2,30.2,30.2,79.3,0,109.5  s-79.3,30.2-109.5,0s-30.2-79.3,0-109.5C203.8,143.5,252.9,143.5,283.1,173.7z" />
              <polygon
                fill="none"
                stroke={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'Polygon' ? '#333333' : 'white'}
                strokeWidth="20"
                strokeMiterlimit="10"
                strokeDasharray="50"
                points="17,494.9 17,18.9 490,18.9 490,351.9 330,494.9 "
              />
            </FilterSVG>
          </FilterButtons>
          <FilterButtons
            title={getTranslatedKey('filterTitleBbox')}
            className="filter-mapa"
            onMouseDown={() => this.filterReset()}
            selected={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'BBOX'}
            onClick={() => this.onFilterClick('BBOX')}>
            <FilterSVG selected={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'BBOX'}>
              <path fill="none" stroke="#333333" strokeWidth="20" strokeMiterlimit="10" strokeDasharray="50" d="M17,18.9" />
              <g>
                <path d="M459.2,0H52.8C23.7,0,0,23.7,0,52.8v406.4C0,488.3,23.7,512,52.8,512h406.4c29.1,0,52.8-23.7,52.8-52.8V52.8   C512,23.7,488.3,0,459.2,0z M52.8,30h406.4c12.6,0,22.8,10.2,22.8,22.8v46.3H30V52.8C30,40.2,40.2,30,52.8,30z M459.2,482H52.8   C40.2,482,30,471.8,30,459.2V129.1h452v330.1C482,471.8,471.8,482,459.2,482z" />
                <path d="M67.9,81.2h31.9c8.3,0,15-6.7,15-15c0-8.3-6.7-15-15-15H67.9c-8.3,0-15,6.7-15,15C52.9,74.5,59.6,81.2,67.9,81.2z" />
                <path d="M144.5,81.2h31.9c8.3,0,15-6.7,15-15c0-8.3-6.7-15-15-15h-31.9c-8.3,0-15,6.7-15,15C129.5,74.5,136.2,81.2,144.5,81.2z" />
                <path d="M224.4,81.2H445c8.3,0,15-6.7,15-15c0-8.3-6.7-15-15-15H224.4c-8.3,0-15,6.7-15,15C209.4,74.5,216.1,81.2,224.4,81.2z" />
              </g>
            </FilterSVG>
          </FilterButtons>
          <FilterButtons
            title={getTranslatedKey('filterTitleSelect')}
            className="filter-selected"
            onMouseDown={() => this.filterReset()}
            selected={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'SELECT'}
            onClick={() => this.onFilterClick('SELECT')}>
            <FilterSVG selected={this.props.taulaSpacialFilter[this.props.layer.getTitle()] === 'SELECT'}>
              <path fill="none" stroke="#333333" strokeWidth="20" strokeMiterlimit="10" strokeDasharray="50" d="M17,18.9" />
              <path
                id="Click"
                d="M256,469.1c-0.7,0-1.4,0-2.1-0.2c-5.4-0.8-9.9-4.7-11.5-10l-85.3-284.2c-1.5-5-0.1-10.4,3.6-14.1  c3.7-3.7,9.2-5.1,14.1-3.6L459,242.4c5.3,1.6,9.2,6.1,10,11.5c0.8,5.4-1.6,10.9-6.2,13.9L392,315l73,73c5.6,5.6,5.6,14.5,0,20.1  L408.1,465c-5.6,5.6-14.5,5.6-20.1,0l-73-73l-47.2,70.8C265.2,466.8,260.7,469.1,256,469.1L256,469.1z M312.8,355.5  c3.8,0,7.4,1.5,10,4.2l75.2,75.2l36.7-36.7l-75.2-75.2c-3-3-4.5-7.2-4.1-11.4c0.4-4.2,2.7-8.1,6.3-10.4l60.1-40.1l-230-69l69,230  l40.1-60.1c2.4-3.5,6.2-5.8,10.4-6.3C311.9,355.5,312.4,355.5,312.8,355.5L312.8,355.5z M123.9,124c5.6-5.6,5.6-14.5,0-20.1  L95.5,75.4c-5.6-5.6-14.5-5.6-20.1,0c-5.5,5.6-5.6,14.5,0,20.1l28.4,28.4c2.8,2.8,6.4,4.2,10,4.2S121.2,126.7,123.9,124z   M113.9,170.7c0-7.8-6.4-14.2-14.2-14.2H57.1c-7.8,0-14.2,6.4-14.2,14.2S49.2,185,57.1,185h42.6C107.5,185,113.9,178.6,113.9,170.7z   M95.5,266l28.4-28.4c5.6-5.6,5.6-14.5,0-20.1c-5.6-5.5-14.5-5.6-20.1,0L75.4,246c-5.6,5.6-5.6,14.5,0,20.1c2.8,2.8,6.4,4.2,10,4.2  S92.8,268.8,95.5,266z M237.6,124L266,95.5c5.6-5.6,5.6-14.5,0-20.1c-5.6-5.5-14.5-5.6-20.1,0l-28.4,28.4c-5.6,5.6-5.6,14.5,0,20.1  c2.8,2.8,6.4,4.2,10,4.2C231.2,128.1,234.8,126.7,237.6,124L237.6,124z M184.9,99.7V57.1c0-7.8-6.4-14.2-14.2-14.2  s-14.2,6.4-14.2,14.2v42.6c0,7.8,6.4,14.2,14.2,14.2S184.9,107.5,184.9,99.7z"
              />
            </FilterSVG>
          </FilterButtons>
        </FilterButtonsWrapper>

        {this.props.taulaSpacialFilter[this.props.layer.getTitle()] !== 'SELECT' && (
          <>
            <FilterOptObl fontSizeEnabled={this.props.fontSizeEnabled}> {getTranslatedKey('filterAlphaNum')} </FilterOptObl>
            {this.renderConditions()}

            <FilterAddButtonsWrapper>
              <FilterAfegirButton fontSizeEnabled={this.props.fontSizeEnabled} onClick={this.handleAddCondition} className="add-condition">
                {this.props.fontSizeEnabled || window.innerWidth < 376 ? getTranslatedKey('filterAddCondReduced') : getTranslatedKey('filterAddCond')}
              </FilterAfegirButton>
              <FilterAfegirButtonSub fontSizeEnabled={this.props.fontSizeEnabled} onClick={this.handleAddSubClause} className="add-subcondition">
                {this.props.fontSizeEnabled || window.innerWidth < 376 ? getTranslatedKey('filterAddSubReduced') : getTranslatedKey('filterAddSub')}
              </FilterAfegirButtonSub>
            </FilterAddButtonsWrapper>
          </>
        )}

        <FilterAddButtonsWrapper>
          <FilterNetejarButton className="delete-filters" fontSizeEnabled={this.props.fontSizeEnabled} onClick={this.handleFilterCancel}>
            {this.props.fontSizeEnabled ? getTranslatedKey('filterDeleteReduced') : getTranslatedKey('filterDelete')}
          </FilterNetejarButton>
          <FilterCercarButton
            fontSizeEnabled={this.props.fontSizeEnabled}
            canApply={this.filtreChecker()}
            disabled={!this.filtreChecker()}
            className={this.filtreChecker() ? 'apply-filter' : ''}
            title={this.state.canApply ? getTranslatedKey('filterApply') : getTranslatedKey('filterTitleCantApply')}
            onClick={() => this.handleClickCerca()}>
            {getTranslatedKey('filterApply')}
          </FilterCercarButton>
        </FilterAddButtonsWrapper>
      </FilterWrapper>
    );
  }
}
